import { useIntl } from "react-intl";
import { admissionsChartData } from "@/lib/tobis-admissions";
import type { TobisAdmissionsPoint } from "@/lib/tobis";
import { AreaStat } from "./TobisMarketCharts";

/**
 * Besucherverlauf DE eines Titels.
 *
 * Ohne SectionColorProvider drumherum faellt AreaStat auf die monochrome
 * Grundfarbe zurueck - genau richtig hier: die farbige Zuordnung aus
 * TobisMarketCharts dient dazu, auf der langen Markt-Seite eine Kachel von
 * der naechsten zu unterscheiden. Auf der Detailseite gibt es nur dieses eine
 * Diagramm.
 */
export function TobisAdmissionsChart({ points }: { points: TobisAdmissionsPoint[] }) {
  const intl = useIntl();
  const data = admissionsChartData(points);
  if (!data) return null;

  const valueLabel =
    data.mode === "total"
      ? intl.formatMessage({
          id: "tobis.title.admissionsSeriesTotal",
          defaultMessage: "Admissions, cumulative",
        })
      : intl.formatMessage({
          id: "tobis.title.admissionsSeriesPeriod",
          defaultMessage: "Admissions in period",
        });

  return (
    <div>
      <AreaStat
        data={data.points}
        xKey="label"
        yKey="value"
        valueLabel={valueLabel}
        height={200}
        tooltipExtra={(label) => {
          const punkt = data.points.find((p) => p.label === label);
          if (!punkt) return null;
          const zeilen = [
            data.mode === "total" && punkt.periodValue != null
              ? intl.formatMessage(
                  {
                    id: "tobis.title.admissionsSeriesInPeriod",
                    defaultMessage: "{count} in this period",
                  },
                  { count: intl.formatNumber(punkt.periodValue) },
                )
              : null,
            punkt.rank != null
              ? intl.formatMessage(
                  { id: "tobis.title.admissionsSeriesRank", defaultMessage: "chart position #{rank}" },
                  { rank: punkt.rank },
                )
              : null,
          ].filter(Boolean);
          return zeilen.length > 0 ? <span>{zeilen.join(" · ")}</span> : null;
        }}
      />
      <p className="mt-2 text-[11px] text-ink/40">
        {intl.formatMessage({
          id: "tobis.title.admissionsSeriesNote",
          defaultMessage:
            "FFA charts. These are rankings, not a full census: months in which the film left the top 100 are missing. The cumulative figure comes from the FFA and carries those gaps.",
        })}
      </p>
    </div>
  );
}
